// extracted by mini-css-extract-plugin
export default {"title":"OfferFormTitle_title__Wy4yx"};